<template>
    <div class="timesheet-sync-state" aria-live="polite">
        <span
            class="timesheet-sync-state__connection"
            :class="`timesheet-sync-state__connection--${api.syncStatus}`"
        >
            <i class="fas fa-circle" aria-hidden="true"></i>
            {{ api.syncStatusLabel }}
        </span>
        <span
            v-if="api.remoteChangePending && api.realtimeInteractionActive"
            class="timesheet-sync-state__pending"
        >
            <i class="fas fa-clock" aria-hidden="true"></i>
            Есть изменения — применим после ввода
        </span>
        <span v-else-if="api.syncNotice" class="timesheet-sync-state__notice">
            <i class="fas fa-check" aria-hidden="true"></i>
            {{ api.syncNotice }}
        </span>
        <span v-if="api.editPendingCount" class="timesheet-sync-state__pending">Сохраняется: {{ api.editPendingCount }}</span>
        <span v-else-if="api.editSyncPending" class="timesheet-sync-state__pending">Обновляем итоги…</span>
        <span v-if="api.editUnsavedCount" :class="api.editErrorCount ? 'text-danger' : 'text-muted'">Не сохранено: {{ api.editUnsavedCount }}</span>
        <collaboration-participants v-if="api.sheet && !api.reviewMode" scope="timesheet"
            :resource-id="api.sheet.timesheet.id"
            :followable-user-ids="api.collaborationUserIds" @select="api.followCollaborator"
            :ready="api.syncStatus === 'connected' && Number(api.watchedTimesheetId) === Number(api.sheet.timesheet.id)" />
    </div>
</template>

<script>
import CollaborationParticipants from '@/components/CollaborationParticipants.vue';
export default {
    name: 'TimesheetSyncStatus',
    components: {CollaborationParticipants},
    props: {api: {type: Object, required: true}}
};
</script>
